import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import {
    redListSpeciesListQuery,
    invasiveSpeciesListQuery,
    predictedSpeciesTotalsQuery,
    RedListSpeciesListQueryResult,
    InvasiveSpeciesListQueryResult,
    PredictedSpeciesTotalsQueryResult,
    PaginatedSpeciesListResponse,
    PredictedSpeciesTotals,
    speciesDetailQuery,
    SpeciesDetailQueryResult,
} from './speciesRiskIndicatorsQuery';

type SpeciesListQueryParams = {
    customerId: string;
    filters?: { name: string; values: string[] }[];
    pagination: { page: number; pageSize: number };
    sortBy?: { field: string; order: 'ASC' | 'DESC' };
};

type SpeciesTotalsQueryParams = {
    customerId: string;
    filters?: { name: string; values: string[] }[];
};

type SpeciesDetailQueryParams = {
    customerId: string;
    scientificName: string;
    filters?: { name: string; values: string[] }[];
};

const SpeciesRiskIndicatorsGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        predictedSpeciesTotals: builder.query<PredictedSpeciesTotals, SpeciesTotalsQueryParams>({
            query: params => ({
                body: predictedSpeciesTotalsQuery,
                variables: params,
            }),
            transformResponse: (response: PredictedSpeciesTotalsQueryResult) => response.portfolio.getPredictedSpeciesTotals,
        }),
        redListSpeciesList: builder.query<PaginatedSpeciesListResponse, SpeciesListQueryParams>({
            query: params => ({
                body: redListSpeciesListQuery,
                variables: params,
            }),
            transformResponse: (response: RedListSpeciesListQueryResult) => response.portfolio.getRedListSpeciesList,
        }),
        invasiveSpeciesList: builder.query<PaginatedSpeciesListResponse, SpeciesListQueryParams>({
            query: params => ({
                body: invasiveSpeciesListQuery,
                variables: params,
            }),
            transformResponse: (response: InvasiveSpeciesListQueryResult) => response.portfolio.getInvasiveSpeciesList,
        }),
        speciesDetail: builder.query<SpeciesDetailQueryResult['portfolio']['getSpeciesDetail'], SpeciesDetailQueryParams>({
            query: params => ({
                body: speciesDetailQuery,
                variables: params,
            }),
            transformResponse: (response: SpeciesDetailQueryResult) => response.portfolio.getSpeciesDetail || { assessments: [] },
        }),
    }),
});

export const { usePredictedSpeciesTotalsQuery, useRedListSpeciesListQuery, useInvasiveSpeciesListQuery, useSpeciesDetailQuery } =
    SpeciesRiskIndicatorsGraphSlice;

export default SpeciesRiskIndicatorsGraphSlice.reducer;
